<template>
  <div class="container-fluid">
    <div class="contents simulator">
      <tab />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-2"
          role="tabpanel"
          aria-labelledby="pills-2-tab"
        >
          <b-form class="row row-cols-sm-auto g-2 mb-4">
            <div class="col-6">
              <input
                type="date"
                class="form-control-lg"
                v-model="searchData.startdate"
              />
            </div>
            <div class="col-6">
              <input
                type="date"
                class="form-control-lg"
                v-model="searchData.enddate"
                name="enddate"
              />
            </div>
            <div class="col-12">
              <div class="input-group">
                <select v-model="searchData.roomno" class="form-select">
                  <option value="0">{{ $t("filter.common.total") }}</option>
                  <template v-for="(rno, index) in roomlist">
                    <option :value="rno.roomnum" :key="index + 'r'">
                      {{ rno.roomname }}
                    </option>
                  </template>
                </select>
                <button
                  class="btn btn-primary btn-lg icon-search"
                  type="button"
                  @click="search"
                ></button>
              </div>
            </div>
          </b-form>

          <table class="table board toggle-xxxl">
            <thead>
              <tr>
                <th>{{ $t("title.simulator.game_no") }}</th>
                <th class="d-none d-sm-table-cell">
                  {{ $t("title.booking.room_name") }}
                </th>
                <th>
                  {{ $t("title.common.nickname") }}<br />
                  <small class="fw-normal text-dgray"
                    >({{ $t("title.simulator.totalplayercount") }})</small
                  >
                </th>
                <th class="d-none d-xxxl-table-cell">
                  {{ $t("title.common.course") }}
                </th>
                <th class="d-none d-xxxl-table-cell">
                  {{ $t("title.common.hole") }}
                </th>
                <th class="d-none d-xl-table-cell">
                  {{ $t("title.simulator.start_time") }}
                </th>
                <th class="d-none d-xl-table-cell">
                  {{ $t("title.simulator.end_time") }}
                </th>
                <th class="d-none d-sm-table-cell">
                  {{ $t("title.common.status") }}
                </th>
                <th class="d-none d-md-table-cell">
                  {{ $t("title.simulator.scorecard") }}
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="roundList.length">
              <template v-for="(item, idx) in roundList">
                <tr :key="idx">
                  <td>{{ item.gameno }}</td>
                  <td class="d-none d-sm-table-cell">{{ item.roomname }}</td>
                  <td>
                    <MemberInfo
                      :nickname="item.nickname"
                      :playerno="item.playerno"
                      :no_img="true"
                    /><br />
                    <small class="text-gray">({{ item.playercnt }})</small>
                  </td>
                  <td class="d-none d-xxxl-table-cell text-start">
                    {{ item.coursename }}
                  </td>
                  <td class="d-none d-xxl-table-cell w-1 fs-14" v-if="item.holetype">
                    {{ item.finished_hole | suffix("H") }} /
                    {{ item.holetype | suffix("H") }}
                  </td>
                  <td class="d-none d-xxl-table-cell" v-else>                   
                  </td>
                  <td class="d-none d-xl-table-cell text-date">
                    {{ item.timezone_starttime | dateformat }}
                  </td>
                  <td class="d-none d-xl-table-cell text-date">
                    {{ item.timezone_endtime | dateformat }}
                  </td>
                  <td class="d-none d-sm-table-cell">
                    {{ item.status | status3 }}
                  </td>
                  <td class="d-none d-md-table-cell">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs"
                      @click="allModalOpen(idx)"
                    >
                      {{ $t("button.common.view") }}
                    </button>
                  </td>
                  <td class="td-arrow end" @click="toggle_tr(idx)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === idx }"
                    />
                  </td>
                </tr>
                <tr
                  class="d-xxxl-none"
                  :class="{ show: view_hide === idx }"
                  :key="idx + 'r'"
                  v-if="view_hide === idx"
                >
                  <td colspan="9">
                    <div class="toggle-content">
                      <div class="row d-sm-none">
                        <div class="col-4">
                          {{ $t("title.booking.room_name") }}
                        </div>
                        <div class="col-8">{{ item.roomname }}</div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.course") }}
                        </div>
                        <div class="col-8">{{ item.coursename }}</div>
                      </div>
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.hole") }}</div>
                        <div class="col-8" v-if="item.holetype">
                          {{ item.finished_hole | suffix("H") }} /
                          {{ item.holetype | suffix("H") }}
                        </div>  
                      </div>

                      <div class="row d-xl-none">
                        <div class="col-4">
                          {{ $t("title.simulator.start_time") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ item.timezone_starttime | dateformat }}
                        </div>
                      </div>

                      <div class="row d-xl-none">
                        <div class="col-4">
                          {{ $t("title.simulator.end_time") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ item.timezone_endtime | dateformat }}
                        </div>
                      </div>

                      <div class="row d-sm-none">
                        <div class="col-4">{{ $t("title.common.status") }}</div>
                        <div class="col-8">{{ item.status | status3 }}</div>
                      </div>

                      <div class="row d-md-none">
                        <div class="col-4">
                          {{ $t("title.simulator.scorecard") }}
                        </div>
                        <div class="col-8">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-xs"
                            @click="allModalOpen(idx)"
                          >
                            {{ $t("button.common.view") }}
                          </button>
                          <!-- <button
                            type="button"
                            class="btn btn-outline-secondary btn-xs"
                            @click="oneModalOpen(idx)"
                          >
                            individual
                          </button> -->
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="9" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>

          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-scorecard-individual"
      ref="modal-scorecard-individual"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">
          {{ $t("title.membership.scorecard") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-scorecard-individual'].hide()"
        ></b-button>
      </template>

      <scorecard
        v-bind:score-card-info="scorecardinfo"
        v-bind:score-card-stats="scorecardstats"
        v-bind:score-card-total="scorecardtotal"
        v-bind:score-card-hole-par="scorecardholepar"
        v-bind:score-card-score="scorecardscore"
        v-bind:sub-course-list="subcourselist"
      />

      <div class="row g-0 border-top-dgray" id="modal-scorecard-total">
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.max_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.maxdriver }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.avg_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.avgdriver }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="d-table-cell"
                >{{ $t("title.common.score") }}({{
                  $t("title.common.shot")
                }})</label
              >
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                <!-- {{
                      Math.sign(
                        scorecardstats.score - scorecardstats.base_par
                      ) > 0
                        ? "+"
                        : ""
                    }}{{ scorecardstats.score - scorecardstats.base_par }} -->
                {{
                  Math.sign(scorecardstats.score - scorecardstats.base_par) > 0
                    ? "+"
                    : ""
                }}{{ scorecardstats.score - scorecardstats.base_par }}
                <small>({{ scorecardstats.score }}) </small>
                <!-- ( {{ scorecardtotal.mulligantotal || 0 }} ) -->
                <!-- {{ scorecardtotal.mulligantotal ? "(" || "" : "" }}
                    {{ scorecardtotal.mulligantotal }}
                    {{ scorecardtotal.mulligantotal ? ")" || "" : "" }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.avg_putts_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.avggreenhit | toFixed }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">{{
                $t("title.common.fareway_hit")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.farewayrate }}%
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">{{
                $t("title.common.gir")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.greenrate }}%
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-scorecard-total"
      ref="modal-scorecard-total"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">
          {{ $t("page.simulator.total_scorecard") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-scorecard-total'].hide()"
        ></b-button>
      </template>

      <h6 class="sub-title">
        {{ $t("title.simulator.roundinfo") }}
      </h6>
      <div
        class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4 table-type header-col p-keep align-middle"
      >
        <div class="col">
          {{ $t("title.simulator.game_type") }}
        </div>
        <div class="col">
          {{ game_mode(scoreCardAll.scorecardinfo.playtype) }}
        </div>

        <div class="col">
          {{ $t("title.common.date") }}
        </div>
        <div class="col">
          <span class="text-date">
            {{ scoreCardAll.scorecardinfo.timezone_date | dateformat }}
          </span>
        </div>

        <div class="col border-bottom-lg-0">
          {{ $t("title.common.location") }}
        </div>
        <div class="col border-bottom-lg-0">
          <span class="shop-name">
            {{ scoreCardAll.scorecardinfo.shopname }}
          </span>
        </div>

        <div class="col">
          {{ $t("title.common.course") }}
        </div>
        <div class="col">
          {{ scoreCardAll.scorecardinfo.coursename }}
        </div>
      </div>

      <h6 class="sub-title mt-4">
        {{ $t("title.simulator.individual_score") }}
      </h6>
      <b-table-simple bordered responsive small>
        <b-thead>
          <b-tr class="bg-gray text-nowrap">
            <b-th sticky-column>{{ $t("title.simulator.players") }}</b-th>

            <b-th>
              <p
                v-if="
                  scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0] &&
                  scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                    .subcourseseq == 1
                "
              >
                {{ $t("title.simulator.out")
                }}<template
                  v-if="
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                  "
                  >({{
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                      ? scoreCardAll.scorecardplayersubcourseinfo
                          .subcourselist[0].subcoursename || ""
                      : ""
                  }})
                </template>
              </p>
              <p v-else>
                {{ $t("title.simulator.in")
                }}<template
                  v-if="
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                  "
                  >({{
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                      ? scoreCardAll.scorecardplayersubcourseinfo
                          .subcourselist[0].subcoursename || ""
                      : ""
                  }})
                </template>
              </p>
            </b-th>

            <b-th>
              <p
                v-if="
                  scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1] &&
                  scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                    .subcourseseq == 2
                "
              >
                {{ $t("title.simulator.in")
                }}<template
                  v-if="
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                  "
                  >({{
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                      ? scoreCardAll.scorecardplayersubcourseinfo
                          .subcourselist[1].subcoursename || ""
                      : ""
                  }})
                </template>
              </p>
              <p v-else>
                {{ $t("title.simulator.in")
                }}<template
                  v-if="
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                  "
                  >({{
                    scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                      ? scoreCardAll.scorecardplayersubcourseinfo
                          .subcourselist[1].subcoursename || ""
                      : ""
                  }})
                </template>
              </p>
            </b-th>
            <!--
            <b-th>
              <div>{{ $t("title.simulator.out") }}</div>
              ({{
                scoreCardAll.scorecardplayersubcourseinfo.subcourselist[0]
                  ? scoreCardAll.scorecardplayersubcourseinfo
                      .subcourselist[0].subcoursename || ""
                  : ""
              }})
            </b-th>
            <b-th
              v-if="
                scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
              "
            >
              <div>{{ $t("title.simulator.in") }}</div>
              ({{
                (scoreCardAll.scorecardplayersubcourseinfo
                  .subcourselist[1] &&
                  scoreCardAll.scorecardplayersubcourseinfo.subcourselist[1]
                    .subcoursename) ||
                ""
              }})
            </b-th> -->
            <!-- <b-th v-else></b-th> -->
            <b-th>{{ $t("title.common.total") }}</b-th>
            <b-th>{{ $t("title.simulator.scorecard") }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(item, index4) in scoreCardAll.scorecardplayerlist"
            :key="index4"
          >
            <b-td sticky-column class="bg-gray">
              {{ item.nickname }}
            </b-td>
            <b-td>
              <span>
                {{ Math.sign(item.scoretotal1) > 0 ? "+" : "" }}
                {{ item.scoretotal1 }}
              </span>
              <span>
                {{ item.shottotal1 ? "(" + item.shottotal1 + ")" || "-" : "-" }}
              </span>
            </b-td>
            <b-td>
              <span>
                {{ Math.sign(item.scoretotal2) > 0 ? "+" : "" }}
                {{ item.scoretotal2 }}
              </span>
              <span>
                {{ item.shottotal2 ? "(" + item.shottotal2 + ")" || "-" : "-" }}
              </span>
            </b-td>
            <b-td>
              <span>
                {{ Math.sign(item.scoretotal) > 0 ? "+" : "" }}
                {{ item.scoretotal }}
              </span>
              <span>
                {{ item.shottotal ? "(" + item.shottotal + ")" || "-" : "-" }}
              </span>
            </b-td>
            <b-td>
              <b-button
                size="xs"
                variant="secondary"
                @click="oneModalOpen(item.playerno, item.define1_pk)"
                :value="item.playernum"
              >
                {{ $t("button.common.view") }}
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { utils } from "@/mixin/utils";
import { myMixin } from "@/mixin/myMixin";
import commonDatePicker from "@/components/common/datepicker/Picker";
import ax from "@/api/round";
import "@/filter/common";
import _ from "lodash";
import tab from "@/components/room/Tab";
import scorecard from "@/components/Scorecard";

export default {
  name: "RoomRound",
  components: {
    tab,
    scorecard,
  },
  mixins: [utils, myMixin],
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs(new Date().setMonth(new Date().getMonth())).format(
            "YYYY-MM-DD"
          ),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs(new Date()).format("YYYY-MM-DD"),
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
        roomno:
          this.$route.query.roomno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].roomno) ||
          0,
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },

      holecnt: 18,
      roomcnt: 0,
      roomlist: [],
      roundList: [],
      page_total: 0,
      data_yn: true,
      activeNickname: "",
      scoreCard: {
        scorecardinfo: {
          nickname: null,
          playtype: null,
          coursenno: null,
          coursename: null,
          shopname: null,
          date: null,
        },
        scorecardsubcourseinfo: {
          subcourselistcnt: null,
          subcourselist: [
            {
              subcourseseq: "",
              subcourseno: "",
              subcoursename: "",
            },
          ],
        },

        scorecardstats: {
          maxdriver: null,
          avgdriver: null,
          shot: null,
          avggreenhit: null,
          farewayrate: null,
          greenrate: null,
        },

        scorecardscore: [],
        // partotal1, partotal2, shottotal1, shottotal2, scoretotal1, scoretotal2, mulligantotal1, mulligantotal2, mulligantotal
        scorecardtotal: [
          {
            partotal1: 0,
            partotal2: 0,
            shottotal1: 0,
            shottotal2: 0,
            scoretotal1: 0,
            scoretotal2: 0,
            mulligantotal1: 0,
            mulligantotal2: 0,
            mulligantotal: 0,
          },
        ],
        holelist: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
      },
      scoreCardAll: {
        playerno: 0,
        playerlist: [],
        scorecardinfo: {
          playtype: null,
          maincourseno: null,
          coursename: null,
          shopname: null,
          date: null,
        },
        scorecardplayersubcourseinfo: {
          subcourselistcnt: null,
          subcourselist: [
            {
              subcourseseq: "",
              subcourseno: "",
              subcoursename: "",
            },
          ],
        },
        scorecardholepar: [],
        scorecardholetotal: {
          holetotal: null,
          partotal: null,
        },
        holelist: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
        scorecardplayerlistcnt: 0,
        scorecardplayerlist: [
          {
            playernum: 0,
            nickname: "",
            scoretotal: 0,
            mulligantotal: 0,
            partotal1: 0,
            partotal2: 0,
            scoretotal1: 0,
            scoretotal2: 0,
            mulligantotal1: 0,
            mulligantotal2: 0,
          },
        ],
        scorecardscorelist: [],
      },
      scorecardinfo: {},
      scorecardstats: {},
      scorecardholepar: [],
      scorecardscore: [],
      // partotal1, partotal2, shottotal1, shottotal2, scoretotal1, scoretotal2, mulligantotal1, mulligantotal2, mulligantotal
      scorecardtotal: {
        partotal1: 0,
        partotal2: 0,
        shottotal1: 0,
        shottotal2: 0,
        scoretotal1: 0,
        scoretotal2: 0,
        mulligantotal1: 0,
        mulligantotal2: 0,
        mulligantotal: 0,
      },
      view_hide: null,
    };
  },
  created() {
    for (let i = 0; i < 18; i++) {
      this.scoreCard.scorecardscore.push({
        holeno: null,
        par: null,
        shot: null,
        score: null,
        mulligan: null,
      });
      // this.scoreCardAll.scorecardholepar.push({
      //   holeno: null,
      //   parno: null,
      // });
    }
    this.init();
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.roomno": function () {
      this.searchData.pageno = 1;
      this.init();
    },

    "searchData.pageno": function () {
      this.init();
    },
  },
  methods: {
    init() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.roundList(this.searchData, (data) => {
        // console.log(data);

        this.total_cnt = data.playlistcnt;
        this.page_total = Math.ceil(
          data.playlistcnt / this.searchData.pagesize
        );
        this.roundList = data.playlist;

        this.get_roomlist();
      });
    },
    get_roomlist() {
      ax.get_roomlist((data) => {
        // console.log(data);
        // alert(data.roomlistcnt);
        if (data) {
          this.roomcnt = data.roomlistcnt;
          this.roomlist = [];
          this.roomlist = data.roomlist;
        } else {
          alert(data);
        }
      });
    },
    get_playerlist(gameNo) {
      ax.get_playerlist(gameNo, (data) => {
        // console.log(data);
        if (data) {
          // alert(data.playerlist[0].playername);
          this.scoreCardAll.playerlist = [];
          this.scoreCardAll.playerlist = data.playerlist;
        } else {
          alert(data);
        }
      });
    },
    searchDateChange(v) {
      // console.log('searchDateChange', v)
    },
    search() {
      this.init();
    },
    allModalOpen(idx) {
      let gameNo = this.roundList[idx].gameno;
      this.holecnt = this.roundList[idx].hole;

      // this.activeNickname = this.roundList[idx].nickname;
      // this.get_playerlist(gameNo);

      ax.scoreCardAll(gameNo, (data) => {
        // alert(gameNo);
        // console.log(data);
        if (data) {
          this.get_playerlist(gameNo);
          this.scoreCardAll.scorecardinfo = data.scorecardinfo;
          this.scoreCardAll.scorecardplayersubcourseinfo =
            data.scorecardplayersubcourseinfo;
          // console.log(this.scoreCardAll.scorecardplayersubcourseinfo);

          // this.scoreCardAll.scorecardholepar = data.scorecardholepar;
          // this.scoreCardAll.scorecardholetotal = data.scorecardholetotal;
          this.scoreCardAll.scorecardplayerlistcnt =
            data.scorecardplayerlistcnt;
          this.scoreCardAll.scorecardplayerlist = data.scorecardplayerlist;
          // this.scoreCardAll.scorecardscorelist = data.scorecardscorelist;
        } else {
          this.scoreCardAll = [];
        }
        this.$refs["modal-scorecard-total"].show();
      });
    },
    oneModalOpen(playernum, gameNo) {
      ax.get_memberscorecard(playernum, gameNo, (flag, data) => {
        if (flag) {
          this.scorecardinfo = data.scorecardinfo;

          this.scorecardstats = data.scorecardstats;
          this.scorecardholepar = data.scorecardholepar;
          this.scorecardscore = data.scorecardscore;
          this.scorecardtotal = data.scorecardtotal;
          this.subcourselist = data.subcourselist;
          this.subcourselistcnt = data.subcourselistcnt;
          this.$refs["modal-scorecard-individual"].show();
        } else {
          alert(data.message);
        }
      });

      this.scoreCardAll.playerno = 0;
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
